import { render, staticRenderFns } from "./SerialRequestCard.vue?vue&type=template&id=7c5ffb50&scoped=true&"
import script from "./SerialRequestCard.vue?vue&type=script&lang=ts&"
export * from "./SerialRequestCard.vue?vue&type=script&lang=ts&"
import style0 from "./SerialRequestCard.vue?vue&type=style&index=0&id=7c5ffb50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5ffb50",
  null
  
)

export default component.exports